<template>
  <router-view style="height: 100% !important" />
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "App",
  computed: mapState({
    settings: (state) => state.settings.data,
  }),
  created() {
    var pathArray = window.location.pathname.split("/");
    // Skip auth check if coming through SSO
    const isSSORoute = pathArray[2] === "access" && pathArray[3] === "sso";

    // Check if URL includes /math/mastery
    const isMathMasteryRoute = window.location.pathname.includes("/math/mastery");

    // Store the original URL in localStorage if it's a math/mastery route
    if (isMathMasteryRoute) {
      localStorage.setItem('originalMathMasteryUrl', window.location.href);
    }

    if (
      this.settings &&
      (!this.settings.login_at ||
        !this.$moment(this.settings.login_at).isSame(this.$moment(), "day")) &&
      pathArray[2] != "start" &&
      pathArray[2] != "login" &&
      pathArray[2] != "demo" && !isSSORoute
    ) {

      var locale = pathArray[1];
      if (
        !locale ||
        locale == "" ||
        (locale != "" && !(locale == "en" || locale == "zh" || locale == "ms"))
      ) {
        window.location.href = window.location.origin + "/en/start";
      } else {
        window.location.href = window.location.origin + "/" + locale + "/start";
      }
      this.$router.push({ name: "PageMainLogin" });
    }
  },
};
</script>
<style>
html {
  background-blend-mode: lighten;
  background-image: url("assets/background/BGTextureLite.jpg");
  background-size: cover;
}
</style>
